import { getLkLink } from '../../../scripts/utils';

export default ['onClick', '$uibModalInstance', function (onClick, $uibModalInstance) {
  this.identificationUrl = getLkLink('identification');
  this.onClick = () => {
    $uibModalInstance.close('identificationError');
    onClick();
  };
}];
